/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

const state = {
  currentTab: 1
};
const getters = {
  getCurrentTab(state) {
    return state.currentTab;
  }
};
const actions = {};
const mutations = {
  goNext(state, tab) {
    state.currentTab = tab;
  }
};

export const estimation = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
